import { createFileRoute } from "@tanstack/react-router";
import { VendorMarktRadarPage } from "@/components/vendor/markt-radar/VendorMarktRadarPage";

export const Route = createFileRoute("/vendor/markt-radar")({
  head: () => ({ meta: [{ title: "Markt-Radar · Venue Portal" }] }),
  component: VendorMarktRadarPage,
});
